import React, { useEffect, FC } from 'react';
import { useLocation } from 'react-router-dom';

import routes from 'src/paths';
import { resolveShell } from 'src/paths/resolveShell';
import { HeaderContainer } from 'src/containers';
import { FooterContainer } from '../footer-container';

/**
 * Route-aware app shell. Rendered inside the Router so header/footer/title
 * react to client-side navigation (fixes stale footer/title on route change).
 */
interface AppShellProps {
  auth: any;
}

export const AppShell: FC<AppShellProps> = ({ auth }) => {
  const { pathname } = useLocation();
  const shell = resolveShell(pathname, routes);

  useEffect(() => {
    document.title =
      pathname === '/' ? 'Home - Discover' : 'Account - Discover';
  }, [pathname]);

  return (
    <>
      {shell.header && auth.isLogged && !auth.isLoading && <HeaderContainer />}
      {shell.footer && <FooterContainer />}
    </>
  );
};
